package com.example.hukakmp.chat

import com.example.hukakmp.identification.GoogleAIBackend
import com.example.hukakmp.identification.getAI
import com.example.hukakmp.identification.getGenerativeModel
import com.example.hukakmp.identification.firebaseAiApp
import kotlinx.coroutines.await

actual val hukaChatAvailable: Boolean = true

private const val MODEL_NAME = "gemini-3.8-flash"

actual suspend fun askHuka(
    message: String,
    history: List<HukaChatMessage>,
): HukaChatResult {
    if (message.isBlank()) return HukaChatResult.Error("Escribí una consulta.")

    return try {
        val backendOptions = js("{}")
        backendOptions.backend = GoogleAIBackend()

        val ai = getAI(firebaseAiApp(), backendOptions)
        val modelParams = js("{}")
        modelParams.model = MODEL_NAME
        val model = getGenerativeModel(ai, modelParams)

        val recentHistory = history.takeLast(8).joinToString("\n") { item ->
            if (item.fromUser) "Pescador: ${item.text}" else "Huka: ${item.text}"
        }

        val prompt = buildString {
            append(SYSTEM_PROMPT)
            if (recentHistory.isNotBlank()) {
                append("\n\nConversación reciente:\n")
                append(recentHistory)
            }
            append("\n\nNueva consulta del pescador:\n")
            append(message.trim())
            append("\n\nRespondé como Huka.")
        }

        val result = model.generateContent(arrayOf<dynamic>(prompt)).await()
        val text = result.response.text().trim()

        if (text.isBlank()) {
            HukaChatResult.Error("Huka no devolvió una respuesta. Probá otra vez.")
        } else {
            HukaChatResult.Success(text)
        }
    } catch (e: Throwable) {
        HukaChatResult.Error(
            when {
                e.message?.contains("permission", ignoreCase = true) == true ->
                    "Firebase AI Logic rechazó la consulta. Revisá la configuración de seguridad del proyecto."
                e.message?.contains("quota", ignoreCase = true) == true ->
                    "La cuota de Huka IA no está disponible en este momento."
                e.message?.contains("network", ignoreCase = true) == true ->
                    "No pude conectarme. Revisá tu conexión e intentá nuevamente."
                else -> "No se pudo consultar a Huka. Intentá nuevamente."
            }
        )
    }
}

private val SYSTEM_PROMPT = """
Sos Huka, un asistente especializado en pesca recreativa de Argentina.

ESTILO:
- Voseo argentino natural.
- Respuestas concretas, útiles y relativamente breves.
- Datos primero; contexto después.
- No empieces con elogios genéricos.
- No inventes normativa, tallas, vedas ni permisos.
- Si una respuesta depende de normativa vigente, indicá que debe verificarse con la autoridad correspondiente.
- Si no sabés algo con suficiente certeza, decilo.

TEMAS:
- especies argentinas
- técnicas y equipos
- carnadas
- horarios y condiciones
- pesca costera, continental y embarcada
- registro de jornadas en Huka
- interpretación general de capturas

FUERA DE TEMA:
Si la consulta no tiene relación con pesca, respondé brevemente con humor amable y reconducí la conversación a pesca.

SEGURIDAD:
La identificación de especies y los consejos de Huka son orientativos. No afirmes que un pez es seguro para consumir basándote únicamente en una descripción o foto.
""".trimIndent()
